import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChain } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import OutsideClick from '../../common/OutsideClick';
import useChainStore from '../../../store/hotel/chain';
import useSearchHooks from '../../../store/hotel/search-hooks';

export default function BrandSelection() {
  const [brandsShow, setBrandsShow] = useState(false);
  const [hotelChainsTxt, setHotelChainsTxt] = useState('');
  const { setChain, search } = useSearchHooks();
  // const [chains, setChains] = useState([]);
  const brandsDiv = useRef(null);
  const { chainList } = useChainStore((state) => {
    return {
      chainList: state.chainList,
    };
  });
  const changeChains = (chain) => {
    const currentChains = search.hotelChain ? search.hotelChain.split(',') : [];
    const chains = _.xor(currentChains, [chain.id.toString()]).join(',');
    setChain({ hotelChain: chains });
    if (chains.length > 1) {
      setHotelChainsTxt(chain.name);
    } else {
      setHotelChainsTxt('');
    }
  };

  const chainListRender = () => {
    if (chainList.length < 1) {
      return (
        <li key={Math.random()}>
          <p>Not Found</p>
        </li>
      );
    }
    return _.map(chainList, (item) => {
      return (
        <li key={item.id}>
          <label htmlFor={item.id}>
            <input
              type="checkbox"
              checked={item.check}
              id={item.id}
              onChange={() => {
                changeChains(item);
              }}
            />
            <p>{item.name}</p>
          </label>
        </li>
      );
    });
  };

  // useEffect(() => {
  //   if (Object.keys(hotelList.chains).length > 0) {
  //     if (hotelList.filter.hotelChain.length) {
  //       setChains([hotelList.chains[hotelList.filter.hotelChain[0]]]);
  //     } else {
  //       setChains(_.orderBy(_.values(hotelList.chains), ['check', 'name'], ['desc', 'asc']));
  //     }
  //   }
  // }, [hotelList.chains, hotelList.filter.hotelChain]);

  return (
    <div className="rs_form_row rs_autosuggest_row rs_1365_100">
      <FontAwesomeIcon icon={faChain} className="fa-location-icon" />
      <div className="rs_date_input_container">
        <div
          className="rs_chk_in"
          onClick={() => {
            setBrandsShow(!brandsShow);
          }}
        >
          <p className={hotelChainsTxt.length >= 1 ? 'check_titles check_title' : 'check_title'}>Hotel Chain</p>
          <p className="check_content" style={{ display: hotelChainsTxt.length >= 1 ? 'block' : 'none' }}>
            {hotelChainsTxt}
          </p>
        </div>
      </div>
      <OutsideClick click={setBrandsShow} listener={brandsShow}>
        <div className="rs_suggest rs_brands" style={{ display: brandsShow ? 'block' : 'none', overflow: 'auto', maxHeight: '120px' }} ref={brandsDiv}>
          <h3>Brands</h3>
          <ul>{chainListRender()}</ul>
        </div>
      </OutsideClick>
    </div>
  );
}
